import { handleBgImage } from './thrive-design-background-images';
import { handleAjaxCall } from './thrive-design-ajax-call';

function handleInteriorPadding() {
    var firstRow = $('#MainCopy_ContentWrapper > .row:first-child'),
        lastRow = $('#MainCopy_ContentWrapper > *:last-child').is('#MainCopy_extraPanel') ? $('#MainCopy_ContentWrapper > .row:nth-last-child(2)') : $('#MainCopy_ContentWrapper > .row:last-child');
    
    if ($(firstRow).hasClass('hl-muted-secondary-row-bkgd') ||
    $(firstRow).hasClass('hl-primary-row-bkgd')) {
        $('#MainCopy_ContentWrapper').addClass('no-top-padding');
    }

    if ($(lastRow).hasClass('hl-muted-secondary-row-bkgd') ||
    $(lastRow).hasClass('hl-primary-row-bkgd')) {
        $('#MainCopy_ContentWrapper').addClass('no-bottom-padding');
    }
}

function handleClickable() {
    $('.clickable').each(function () {
        var self = $(this),
            link = $(self).find('a'),
            onclick = $(link).attr('onclick'),
            href = $(link).attr('href'),
            target = $(link).attr('target');

        if (!!onclick) {
            $(self).wrapInner('<a onclick="' + onclick + '" />');
        } else {
            var target = $(link).attr('target'),
                rel = $(link).attr('rel');

            if (target === '_blank') {
                $(self).wrapInner('<a href="' + href + '" target="' + target + '" rel="' + rel + '" />');
                $(link).closest('p').addClass('card-link');
            }
            if (target === 'self' || target === undefined) {
                $(self).wrapInner('<a href="' + href + '" />');
                $(link).closest('p').addClass('card-link');
            }
        }

        if ($(link).parent().is('h3') ||
            $(this).hasClass('link-text') ||
            $(self).hasClass('icon-card') ||
            $(self).hasClass('icon-circle')) {
            $(link).contents().unwrap();
        } else {
            $(link).hide();
        }
    });
}

function handleEvents() {
    $('.HLLandingControl.HLEventList ul li').each(function () {
        var self = $(this),
            month = $(self).find('.date-block .calendar-month span').text();

        month = month.substring(0, 3);
        $(self).find('.date-block .calendar-month').text(month);
    });
}

function handleSlider() {

    /* ===============================
       HERO SLIDER
    =============================== */
    $('.hero-slide').each(function () {
        var $group = $(this).parent();

        if (!$group.hasClass('hero-slider')) {
            $group.addClass('hero-slider');
        }
    });

    $('.hero-slider').not('.slick-initialized').slick({
        dots: true,
        arrows: true,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 7000,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow:
            '<button type="button" class="slick-arrow prev-arrow">' +
            '<span class="sr-only">Back</span>' +
            '<i class="fa-solid fa-chevron-left"></i></button>',
        nextArrow:
            '<button type="button" class="slick-arrow next-arrow">' +
            '<span class="sr-only">Next</span>' +
            '<i class="fa-solid fa-chevron-right"></i></button>',
        responsive: [{
            breakpoint: 1200,
            settings: { arrows: false }
        }]
    });


    /* ===============================
       MEMBER HOME SLIDER
    =============================== */
    $('.memberhome-slide').each(function () {
        var $slide = $(this);

        if (!$slide.find('.img-container').length) {
            $slide.append('<div class="img-container"></div>');
            handleBgImage($slide, $slide.find('.img-container'));
            $slide.find('img').closest('p').remove();
            $slide.find('img').remove();
        }

        $slide.parent().addClass('memberhome-slider');
    });

    $('.memberhome-slider').not('.slick-initialized').slick({
        dots: true,
        arrows: true,
        infinite: true,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow:
            '<button type="button" class="slick-arrow prev-arrow">' +
            '<i class="fa-solid fa-chevron-left"></i></button>',
        nextArrow:
            '<button type="button" class="slick-arrow next-arrow">' +
            '<i class="fa-solid fa-chevron-right"></i></button>'
    });



    /* ===============================
       SLIDE CONTENT SLIDER
    =============================== */
    $('.slide-content').each(function () {
        var $group = $(this).parent();
        $group.addClass('slide-content-wrapper');

        if ($(this).hasClass('white-text')) {
            $group.addClass('white-text');
        }
    });

    $('.slide-content-wrapper').not('.slick-initialized').slick({
        dots: true,
        arrows: true,
        infinite: true,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow:
            '<button type="button" class="slick-arrow prev-arrow">' +
            '<i class="fa-solid fa-chevron-left"></i></button>',
        nextArrow:
            '<button type="button" class="slick-arrow next-arrow">' +
            '<i class="fa-solid fa-chevron-right"></i></button>'
    });



    /* ===============================
       GENERIC SLIDER
    =============================== */
    $('.slide').each(function () {
        $(this).parent().addClass('slider');
    });

    $('.slider')
        .not('.hero')
        .not('.slick-initialized')
        .slick({
            dots: true,
            arrows: true,
            infinite: true,
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow:
                '<button type="button" class="slick-arrow prev-arrow slick-prev">' +
                '<span class="sr-only">Back</span>' +
                '<i class="fa-solid fa-chevron-left"></i></button>',
            nextArrow:
                '<button type="button" class="slick-arrow next-arrow slick-next">' +
                '<span class="sr-only">Next</span>' +
                '<i class="fa-solid fa-chevron-right"></i></button>'
        });

}


function handleFeaturedCarouselTiles() {

    /* ===============================
       FEATURED CARDS - MAKE CAROUSEL TILES
    =============================== */
    $('.make-carousel-tiles ul').not('.slick-initialized').slick({
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow:
            '<button type="button" class="slick-arrow prev-arrow">' +
            '<span class="sr-only">Back</span>' +
            '<i class="fa-solid fa-chevron-left"></i></button>',
        nextArrow:
            '<button type="button" class="slick-arrow next-arrow">' +
            '<span class="sr-only">Next</span>' +
            '<i class="fa-solid fa-chevron-right"></i></button>',
        responsive: [{
            breakpoint: 991,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
            }
        }]
    });
}

function handlePromoTile() {
    var promoTile = $('.promo-tile'),
        link = $(promoTile).find('a');

    if (!!($(link).attr('href'))) {
        $(promoTile).wrapInner('<a href="' + $(link).attr('href') + '" target="' + $(link).attr('target') + '" rel="' + $(link).attr('rel') + '" />');
        $(promoTile).find('a a').remove();
    }
}

function handleHero() {
    if (!!($('.hero').html())) {
        var classList = $('.hero').attr('class').split(' ');
    
        for (var i = 0; i < classList.length; i++) {
            if (classList[i].indexOf('-bkgd') > -1 ||
            classList[i].indexOf('bg-') > -1) {
                return;
            }
        }

        $('.hero').each(function() {
            handleBgImage($(this), $(this));
        });

    }
}

function handlePageTitleBg() {
    var src = $('.page-title-bg img').attr('src');

    if (!!(src)) {
        handleBgImage($('.page-title-bg'), $('#InteriorPageTitle'));
        $('#InteriorPageTitle').addClass('has-bg-img');
    }
}

function handleImageCards() {

    $('.ContentItemHtml.card.img-card').each(function() {
        let Img = $(this).find('img');
        let ImgSrc = $(Img).attr('src');
        $(this).prepend('<div class="img-container" style="background-image: url('+ ImgSrc +'"></div> ');
        $(Img).parent().remove();
    });
}

function handleDiscussionByLine() {
    $('.discussions .HLLandingControl ul li').each(function () {
        var self = $(this),
            byline = $(self).find('.ByLine'),
            bylineLink = $(byline).find('a'),
            postedIn = $(self).find('h5');

        // handle errant comma

        $(bylineLink).insertBefore(byline);
        var trimmedByline = $(byline).text().trim().slice(1, $(byline).text().trim().length);
        $(byline).text(trimmedByline);
        $(bylineLink).prependTo(byline);

        // handle community
        $(postedIn).find('a:not([id*="ContainerLink"])').insertAfter($(bylineLink));
        $(bylineLink).after(' in ');
        $(postedIn).hide();
    });
}

function handleFeaturedMember() {
    $('.member-card').each(function () {
        var self = $(this),
            img = $(self).find('img').closest('strong'),
            name = $(self).find('h3'),
            heading = $(self).find('h2');

        $(img).wrap('<div class="user-details" />');
        $(name).appendTo('.user-details');
        $(heading).wrap('<div class="ContentUserControl" />');
        $('p .user-details').unwrap();
    });
}

function handleByLineAndLink(self) {
    var img = $(self).find('a[id*="lnkDisplay"]'),
        byline = $(self).find('.ByLine'),
        bylineLink = $(byline).find('a');

    if (!!$(bylineLink).html()) {
        $(bylineLink).insertBefore(byline);
        
        var text = $(byline).text();
        text = $.trim(text);
        text = text.substring(4, text.length);
        text = $.trim(text);

        $(byline).text(text);
        $(byline).prepend(bylineLink);

    }

    if (!!($(img).find('img').attr('src'))) {
        $(img).prependTo(byline);
    }
}

function handleResources() {
    $('.col-md-6 .HLMyDocuments ul li').each(function() {
        var self = $(this);

        handleAjaxCall(self);
        handleByLineAndLink(self);
    });

    $('.HLMyDocuments .Content ul li').each(function () {
        var self = $(this);

        // handle icons
        var iconContainer = $(self).find('.libListReptEntAttchLble').parent();

        $(iconContainer).prependTo(self);

        $(self).find('.listIconContainer a').contents().unwrap();
        $(self).find('.listIconContainer img').parent().addClass('has-image');

        $(self).find('.listIconContainer').each(function () {
            var container = $(this);

            if (!($(container).find('> *').html())) {
                var text = $(container).text();

                text = $.trim(text);
                $(container).text(text);
            }
        });
    });
}

function handleBlogs() {
    $('.col-md-6 .HLRecentBlogs ul li').each(function () {
        var self = $(this);

        // handle image

        handleAjaxCall(self);

        // handle byline and user image
        handleByLineAndLink(self);
    });
}

function handleFeaturedCards() {
    $('.featured-cards ul:not(.pagination) li, .featured-resource.make-carousel-tiles ul li').each(function () {
        handleAjaxCall(this);
    });
}

function handleInteriorCards() {
    $('.list-tiles ul:not(.pagination) li, .list-tiles .blogs-block').each(function () {
        handleAjaxCall(this);
    });
}

function handleAllContentListIcons() {
    $('.SearchResults .Content ul li').each(function () {
        var self = $(this),
            href = $(self).find('h3 a').attr('href');

        if (href.indexOf('blog') > -1) {
            $(self).addClass('acl-blog');
        } else if (href.indexOf('viewdocument') > -1) {
            $(self).addClass('acl-library');
        } else if(href.indexOf('discussion') > -1) {
            $(self).addClass('acl-discussion');
        }else if(href.indexOf('event') > -1) {
            $(self).addClass('acl-event');
        }
    });
}

function handleTTLbar() {
  var $TTL = $(".ttl-bar");

  // If there is no .ttl-bar on the page, do nothing
  if (!$TTL.length) return;

  function moveTextLinks() {
    if (window.innerWidth <= 992) {
      $TTL.appendTo(".navbar-collapse .nav");
    } else {
      $TTL.prependTo("#NAV");
    }
  }

  // Run once on init
  moveTextLinks();

  // Remove previous handler (if any) then bind a fresh one
  $(window)
    .off("resize.handleTTLbar")
    .on("resize.handleTTLbar", moveTextLinks);
}

function handleWelcomeUser() {
    $("body.ribbit #MPOuterMost #MPOuter .welcome-user .ProfileUserName")
        .wrap('<div class="ContentItemHtml"></div>');

    $("body.ribbit #MPOuterMost #MPOuter .welcome-user .ProfileUserName span")
        .prepend("Welcome back, ")
        .append("!");

    $(".welcome-user h2 span, h2.ProfileUserName > span").each(function () {
        const span = $(this);
        const text = span.text().trim();
        const match = text.match(/^(Welcome back,\s*)(.+?)(!?)$/i);

        if (!match) return;

        span.html(
            `${match[1]}<span class="welcome-user-name">${match[2]}</span>${match[3]}`
        );
    });
}

function handleTestimonySlides() {
  $(".slide-content.testimony.card").each(function () {

    if ($(this).find(".author-position-byline").length) {
      return;
    }

    const htmlContent = $(this).find(".HtmlContent");
    const imgContainer = $(this).find(".img-container");

    htmlContent.append('<div class="img-author-byline" />');

    const authorByline = $(this).find("h4");
    const positionByline = $(this).find("h6");
    const authorPositionByline = $('<div class="author-position-byline" />');

    authorPositionByline.append(authorByline);
    authorPositionByline.append(positionByline);

    authorPositionByline.prependTo(htmlContent.find(".img-author-byline"));
    imgContainer.prependTo(htmlContent.find(".img-author-byline"));
  });
}

$(function () {
    handleInteriorPadding();
    handleClickable();
    handleEvents();
    handleSlider();
    handleFeaturedCarouselTiles();
    handlePromoTile();
    handleHero();
    handlePageTitleBg();
    $('.people-you-should-know .HLLandingControl').append($('.suggested-contacts-btn'));
    handleImageCards();
    handleDiscussionByLine();
    handleFeaturedMember();
    handleBlogs();
    handleResources();
    handleFeaturedCards();
    handleAllContentListIcons();
    handleInteriorCards();
    handleTTLbar();
    handleWelcomeUser();
    handleTestimonySlides();

    if (window.Sys && Sys.WebForms && Sys.WebForms.PageRequestManager) {
        Sys.WebForms.PageRequestManager.getInstance().add_endRequest(function () {
            handleResources();
            handleInteriorCards();
            handleFeaturedCarouselTiles();
        });
    }
});